import React, { useEffect } from 'react';
import { clearHeldFacebook } from '../utils/facebookLogin';
import './FacebookLinkNotice.css';

// Pop-up shown when "Continue with Facebook" finds the email already has an
// account (made with Google, or with email). It asks before connecting:
// "Yes" runs the page's Google sign-in, which proves it's the same person,
// logs them in and links Facebook to that account (utils/facebookLogin.js
// linkHeldFacebook) — after that either button logs them in.
const FacebookLinkNotice = ({ email, onGoogle, onClose }) => {
  const close = () => { clearHeldFacebook(); onClose?.(); };

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') close(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="fb-link-overlay" onClick={close}>
      <div className="fb-link-modal" role="dialog" aria-modal="true" aria-labelledby="fb-link-title" onClick={(e) => e.stopPropagation()}>
        <div className="fb-link-icons" aria-hidden="true">
          <svg width="30" height="30" viewBox="0 0 18 18"><path fill="#1877F2" d="M18 9a9 9 0 1 0-10.406 8.89v-6.29H5.309V9h2.285V7.017c0-2.256 1.344-3.503 3.4-3.503.985 0 2.015.176 2.015.176v2.215h-1.135c-1.118 0-1.467.694-1.467 1.406V9h2.496l-.4 2.6H10.41v6.29A9.002 9.002 0 0 0 18 9z"/></svg>
          <span className="fb-link-plus">+</span>
          <svg width="30" height="30" viewBox="0 0 18 18">
            <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908C16.618 14.013 17.64 11.706 17.64 9.2z"/>
            <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"/>
            <path fill="#FBBC05" d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"/>
            <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 6.29C4.672 4.163 6.656 3.58 9 3.58z"/>
          </svg>
        </div>
        <h3 id="fb-link-title" className="fb-link-title">Connect your Facebook to your account?</h3>
        <p className="fb-link-text">
          You&apos;ve already joined{email ? <> as <strong>{email}</strong></> : ''}.
          To check it&apos;s you, sign in with Google once. We&apos;ll log you in and connect Facebook,
          so either button works from now on.
        </p>
        <button type="button" className="social-btn social-btn-google fb-link-yes" onClick={(e) => { onClose?.(); onGoogle?.(e); }}>
          Yes, connect with Google
        </button>
        <button type="button" className="fb-link-no" onClick={close}>Not now</button>
        <p className="fb-link-small">Joined with your email instead? Choose Not now and log in with your email.</p>
      </div>
    </div>
  );
};

export default FacebookLinkNotice;
